(function (angular) {
  "use strict";

  angular.module("Toyota.Services").service("OnScreenDebugLogger", [
    "$timeout",
    function ($timeout) {
      var api = {};
      var maxBufferLength = 10;
      var enabled = false;
      var $log;

      function init() {
        $log = angular.element("#onscreenDebugLogger");
        if (!$log.length) {
          $log = angular.element(
            '<div id="onscreenDebugLogger" style="font-size: 10px; font-family: monospace; position: fixed; top: 0; left: 0; right: 0; z-index: 9999; color: #00FF00; background: rgba(0,0,0,0.5); -webkit-backdrop-filter: blur(20px);"></div>'
          );
          $timeout(function () {
            angular.element("body").prepend($log);
          });
        }
      }

      var buffer = [];

      api.log = function (log) {
        if (!enabled) {
          return;
        }

        var now = new Date();
        var hours = now.getHours();
        var min = now.getMinutes();
        var sec = now.getSeconds();
        var msec = now.getMilliseconds();
        min = min.length < 2 ? "0" + min : min;
        sec = sec.length < 2 ? "0" + sec : sec;
        msec = msec.length < 3 ? new Array(4 - msec.length).join("0") + msec : msec; // eslint-disable-line no-magic-numbers
        var timestamp = hours + ":" + min + ":" + sec + "." + msec;
        buffer.push(timestamp + "   " + log);

        if (buffer.length > maxBufferLength) {
          buffer.shift();
        }

        $log.html(buffer.join("<br />"));
      };

      if (enabled) {
        init();
      }

      return api;
    },
  ]);
})(window.angular);
